module.exports = __webpack_public_path__ + "static/media/logo_Darwined.6d41182f.svg";